// extracted by mini-css-extract-plugin
export default {"label":"EQqJYHb6MXzqEghhUdCQXw==","copyBtn":"BSTSK+U3c13gub5+43--jA=="};